import React from 'react';

import LoginButton from './LoginButton';

const LoggedOutComponent = () => (
    <div className="flex-container-h flex-center-alt">
        <div className="connexion bt-popup-connexion hidden-mobonly">
            <LoginButton />
        </div>
    </div>
);

export default LoggedOutComponent;



// WEBPACK FOOTER //
// ./src/components/header/membernav/LoggedOutComponent.js